/*
  Blog sort toggle: newest first / oldest first.  (Igor 2026-09-13)

  "it should also have the option to change the order from newest first to
   older first. so those 2 order options in the filters"

  WHY THIS IS CLIENT-SIDE, and the honest limitation.

  Shopify Liquid does not expose arbitrary query parameters, so a section
  cannot read `?sort=oldest` and re-order server-side. Blog pagination also
  happens before any Liquid filter could reverse the array. So this reorders
  the articles ON THE CURRENT PAGE.

  With per_page at 10 and eight articles in the blog there is exactly one page,
  so today it is exact. Once the blog passes ten articles it sorts within the
  page the visitor is on, which is a real limitation and is recorded here
  rather than hidden.

  Order is taken from the DOM, not from a date string: the cards already render
  newest-first, so reversing them is the oldest-first order without parsing any
  locale-formatted date.
*/
(function () {
  'use strict';

  function start() {
    var btn = document.querySelector('[data-hm-blog-sort]');
    if (!btn) return;

    var grid = document.querySelector('.blog-articles, .blog__posts');
    if (!grid) return;

    var label = btn.querySelector('[data-hm-sort-label]');
    var labels = window.hmBlogSortLabels || { newest: 'Nieuwest eerst', oldest: 'Oudste eerst' };
    var oldestFirst = false;

    /*
      Select the CARDS, not grid.children. The featured hero and the filter and
      sort controls are SIBLINGS of the cards inside the same container, so
      reversing children reordered those too and the first click dropped the
      hero into the middle of the list. Measured on the deployed page.
    */
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.blog-articles__article'));
    if (cards.length < 2) return;

    // Snapshot the server order once. Re-reading after a reverse would make
    // the second click a no-op.
    var original = cards.slice();

    btn.addEventListener('click', function () {
      oldestFirst = !oldestFirst;
      var order = oldestFirst ? original.slice().reverse() : original;
      // appendChild MOVES an existing node, so this reorders without cloning
      // and without losing any listener the cards carry.
      order.forEach(function (el) { grid.appendChild(el); });
      if (label) label.textContent = oldestFirst ? labels.oldest : labels.newest;
      btn.setAttribute('aria-pressed', String(oldestFirst));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
